import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssueFieldConfigurationSchemesRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-field-configuration-schemes',
	path: '/jira/settings/issues/field-configuration-schemes',
	exact: true,
};
